import { FxConverter } from '@/components/FxConverter'
import { PageHero } from '@/components/PageHero'
import { company } from '@/config/company'
import { useRates } from '@/context/RatesContext'

export function CalculatorPage() {
  const { fxRates } = useRates()

  return (
    <>
      <PageHero
        title="Hesaplama"
        subtitle={`${company.name} — ${company.legalName}`}
      />
      <FxConverter rates={fxRates} />
    </>
  )
}
